// extracted by mini-css-extract-plugin
module.exports = {"LFPBatteries":"LFPBatteries_LFPBatteries__il8k8","batteries_text":"LFPBatteries_batteries_text__nXuhw"};